import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import NightSky from './NightSky';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className='w-full h-full flex justify-center items-center '>
      <NightSky />
      <App /> 
    </div>
  </React.StrictMode>
);
